import React from "react";
import {Element} from "react-scroll";
import ComparisonTableWithArrow from "../table/ComparisionTableWithArrow";

interface ComparisionProps{
    currentLevel?: data;
    threeYearAgo?: data;
    feedbackAssisstant: Map<string, string>
}
interface data {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
}
const Comparison: React.FC<{ data: ComparisionProps, content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean }> = ({ data, content, defaultTemplate }) => {
    return (
        <Element name="comparison">
            <div className={"div-section"} style={{marginTop: '48px'}}>
                <div style={{height: '40px'}}>
                    <span className="title-section">
                        {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : '3年前と現在の比較' : '3年前と現在の比較'}
                    </span>
                </div>

                <div className={"border-title"}>
                    <div className={"underline-title-three-year-ago"}></div>
                </div>
                {
                    data.threeYearAgo && data.currentLevel &&
                    <ComparisonTableWithArrow data={{threeYearAgo: data.threeYearAgo, currentLevel: data.currentLevel,
                        feedback: (content?.FEEDBACK?.[0] || defaultTemplate) ? data.feedbackAssisstant.get('3') != null ? data.feedbackAssisstant.get('3') : '' : ''}}
                                              text={(content?.TEXT?.[0] || defaultTemplate) ? typeof content?.TEXT?.[0] === "string" ? content?.TEXT?.[0] : '' : ''}/>
                }
            </div>
        </Element>
    );
};

export default Comparison;
